// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__oBBHD","rotation":"Loading_rotation__w0ocr"};